import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2026 Sriram Yerramsetty </p>
        </footer>
    );
};

export default Footer;